import React, {useEffect} from 'react';
import { getChurn } from '../../slices/dashboard';
import { useSelector, useDispatch } from 'react-redux'
import { Card } from '.';
import { formatPercentage } from '../../utils';


export const ChurnCard = () => {

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getChurn())
    }, [])

    const churn = useSelector((state) => state.dashboard.churn?.churn);

    return (
        Card({backgroundColor: 'bluegreen', fontColor: 'white', heading: gettext('Churn Rate'), number: formatPercentage(churn*100, 2)})
    );
};